// Estilos exclusivos do DiagramaPreview (título da seção Diagrama de
// Equipamentos) — extraídos de styles.js (2.3-circuito) na Task 7 da
// decomposição.
const styles = () => ({
	boxContent: {
		display: "flex",
		alignItems: "center",
		gap: 1,
		mb: 1,
		mt: 2,
	},
});

export default styles;
